import { render, staticRenderFns } from "./DsfrTagGroup.vue?vue&type=template&id=379d7d93&"
import script from "./DsfrTagGroup.vue?vue&type=script&lang=js&"
export * from "./DsfrTagGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports